import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'list-pager',
	templateUrl: './list-pager.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ListPagerComponent implements OnInit {
	
	@Input() totalItems: any;
	@Input() pageSize: any | undefined;
	@Input() currentPage: any;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>();
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		
		this.vm.setPage = this.setPage;
		this.vm.setPreviousPage = this.setPreviousPage;
		this.vm.setNextPage = this.setNextPage;
		this.vm.numberOfPages = this.numberOfPages;
	};

	numberOfPages() {
		return this.vm.totalItems > 0 ? Math.ceil(this.vm.totalItems / this.vm.pageSize) : 0;
	}

	setPage(index) {
		this.vm.currentPage = index;
		this.currentPageChange.emit(this.vm.currentPage);
	}

	setPreviousPage() {
		if (this.vm.currentPage > 0) {
			this.vm.currentPage--;
			this.currentPageChange.emit(this.vm.currentPage);
		}
	}

	setNextPage() {
		if (this.vm.currentPage < this.numberOfPages() - 1) {
			this.vm.currentPage++;
			this.currentPageChange.emit(this.vm.currentPage);
		}
	}
	
}